import React from 'react';
import Button from 'screens/components/basic/Button';
import SelectInput from 'screens/components/basic/SelectInput';
import LOOKUP from 'constants/lookup';
import DatePickerInput from 'screens/components/basic/DatePickerInput';
import VisibilityIcon from '@mui/icons-material/Visibility';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import BranchMultiSelectAutoCompleteInput from 'screens/components/basic/BranchMultiSelectAutoCompleteInput';
import CheckInput from 'screens/components/basic/CheckInput';
import CardSimple from 'screens/components/basic/CardSimple';

const componentName = "AggregateBranchSalesInventory";

const Header = (props) => (
    <CardSimple className="p-1">
        <div className="row row_margin_none">
            <div className="row">
                <div className="col-xs-12 col-sm-6 col-md-3">
                    <SelectInput
                        name={componentName + "DateRangeType"}
                        fullWidth={true}
                        defaultValue={"custom"}
                        label={"Date Range Type"}
                        floatingLabelText={"Date Range Type"}
                        hintText={"Date Range Type"}
                        options={props.dateRangeTypeOptions && props.dateRangeTypeOptions.length > 0 ? props.dateRangeTypeOptions : []}
                    />
                </div>
                {props.selectedDateRangeType == "custom" ?
                    <div className="col-xs-12 col-sm-6 col-md-3">
                        <DatePickerInput
                            name={componentName + LOOKUP.report.common.beginDate.name}
                            floatingLabelText={LOOKUP.report.common.beginDate.label + "*"}
                            hintText={LOOKUP.report.common.beginDate.label + "*"}
                            fullWidth={true}
                            required
                        />
                    </div> : null
                }
                {props.selectedDateRangeType == "custom" ?
                    <div className="col-xs-12 col-sm-6 col-md-3">
                        <DatePickerInput
                            name={componentName + LOOKUP.report.common.endDate.name}
                            floatingLabelText={LOOKUP.report.common.endDate.label + "*"}
                            hintText={LOOKUP.report.common.endDate.label + "*"}
                            fullWidth={true}
                        />
                    </div> : null
                }
                {props.selectedDateRangeType == "custom" ?
                    <div className="col-xs-12 col-sm-6 col-md-3">
                        <SelectInput
                            name={componentName + "GroupBy"}
                            fullWidth={true}
                            defaultValue={"Month"}
                            label={"Report By"}
                            floatingLabelText={"Report By"}
                            hintText={"Report By"}
                            options={props.groupByOptions && props.groupByOptions.length > 0 ? props.groupByOptions : []}
                        />
                    </div> : null
                }
            </div>
            <div className="row">
                <div className="col-xs-12 col-sm-6">
                    <BranchMultiSelectAutoCompleteInput
                        defaultValues={localStorage.getItem("AggregateBranchSalesInventoryBranchIds") != null ? localStorage.getItem("AggregateBranchSalesInventoryBranchIds").split(",").map(item => { return ({ value: item }) }) : props.branchOptions.map(item => { return ({ value: item.value }) })}
                        name={`${componentName}BranchIds`}
                        fullWidth={true}
                        autoWidth={true}
                        label="Branches"
                        floatingLabelText="Branches"
                        hintText="Branches"
                        style={{ fontFamily: "Open Sans, Arial, Helvetica, sans-serif", fontSize: "16px", letterSpacing: "-0.25px" }}
                        options={props.branchOptions}
                        fieldName={'Branches'}
                    />
                </div>
                <div className="col-xs-12 col-sm-6">
                    <CheckInput text="Include Inventory Value (Slower)" value={false} name={componentName + "IncludeInventoryValue"} />
                </div>
            </div>
            <div className="row">
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 pb-2">
                    <Button
                        type="IconInButton"
                        className="pull-right mt-2 ml-1 btnNewBrandPOS"
                        name={componentName + LOOKUP.report.common.viewReport.name}
                        label={LOOKUP.report.common.viewReport.label}
                        icon={<VisibilityIcon />}
                        onTouchTap={props.showBody}
                    />
                    <Button
                        type="DownloadButton"
                        className="pull-right mt-2 btnNewBrandPOS"
                        name={componentName + LOOKUP.report.common.downloadReport.name}
                        label={LOOKUP.report.common.downloadReport.label}
                        onTouchTap={props.download}
                    />
                </div>
            </div>
            <br />
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <p className="purpleText"><b>Note: </b><strong className="blue-text"><i>Only completed & partially refunded orders will be counted in this report, the profit may change based on the change in the cost of the products.</i></strong></p>
                <p><b><i>The Total Gross Profit is calculated using Exact Cost.</i></b></p>
            </div>
        </div>
    </CardSimple>
);

export default Header;
